import { render, staticRenderFns } from "./ProfileBox.vue?vue&type=template&id=710f919f&scoped=true"
import script from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileBox.vue?vue&type=style&index=0&id=710f919f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f919f",
  null
  
)

export default component.exports